import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import theme from './Checkbox.scss';

const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

const Checkbox = ({ size, error, register, ...others }) => (
  <div
    className={classNames(theme.Checkbox, theme[size], {
      [theme.InputError]: error,
    })}
  >
    <input className={theme[size]} type="checkbox" ref={register} {...others} />
    {error && <span className={theme.ErrorText}>{error}</span>}
  </div>
);

Checkbox.propTypes = {
  size: PropTypes.string,
  error: PropTypes.string,
  register: PropTypes.func,
};

Checkbox.defaultProps = {
  size: SIZES.medium,
};

export default Checkbox;
